mutation connectOnofficeUser($input: ConnectOnofficeUserInput!) {
  connectOnofficeUser(input: $input)
}
